import React from 'react';
import { SidebarButton } from 'screens/AssetViewerUI';
import MarkAsDone from './MarkAsDone';
function FullscreenActions() {
  return /*#__PURE__*/React.createElement(MarkAsDone, {
    as: SidebarButton
  });
}
export default FullscreenActions;